export type LieuStatut = 'pending' | 'published' | 'draft';

export interface LieuPhoto {
  url: string;
  alt: string;
}

export interface Lieu {
  id: string;
  nom: string;
  slug: string;
  statut: LieuStatut;
  is_partenaire: boolean;
  is_featured: boolean;

  description_courte: string | null;
  description: string | null;
  type_lieu: string[];
  amenities: string[];

  capacite_min: number | null;
  capacite_max: number | null;
  superficie_m2: number | null;
  capacite_cocktail: number | null;
  capacite_banquet: number | null;
  capacite_theatre: number | null;
  types_evenements: string[];

  adresse: string | null;
  quartier: string | null;
  ville: string;
  /** Code ISO 3166-1 alpha-2 (« FR » par défaut). Hors de France : ni quartier ni département. */
  pays?: string;
  code_postal: string | null;
  departement: string | null;

  tarif_minimum: number | null;
  tarif_indicatif: string | null;
  duree_minimum: string | null;
  contraintes: string | null;

  contact_nom: string | null;
  email_contact: string | null;
  telephone: string | null;
  site_web: string | null;
  instagram: string | null;
  video_url: string | null;

  photo_couverture: string | null;
  photos: LieuPhoto[];

  seo_title: string | null;
  seo_description: string | null;

  submitted_by_venue: boolean;
  notes_admin: string | null;
  /** Lieu candidat : comment il a connu Maison Eridia (constants/sourcesConnaissance). */
  comment_connu?: string | null;
  comment_connu_precision?: string | null;

  created_at: string;
  updated_at: string;
}

export type LieuInsert = Omit<Lieu, 'id' | 'created_at' | 'updated_at'>;
export type LieuUpdate = Partial<Omit<LieuInsert, 'submitted_by_venue'>>;

export const TYPES_LIEU = [
  'Château',
  'Loft',
  'Rooftop',
  'Salle de réception',
  'Hôtel particulier',
  'Espace industriel',
  'Restaurant privatisable',
  'Jardin / Parc',
  'Péniche',
  'Musée / Galerie',
  'Coworking haut de gamme',
  'Villa',
  'Cave / Cave à vins',
  'Espace atypique',
  'Boutique Hôtel',
  'Théâtre / Salle de spectacle',
] as const;

export const TYPES_EVENEMENTS_OPTIONS = [
  'Mariage',
  'Séminaire',
  'Team building',
  'Soirée gala',
  'Lancement de produit',
  'Conférence',
  'Anniversaire',
  'Réception corporate',
  'Dîner de gala',
  'Exposition',
  'Demande en mariage',
  'EVJF / EVG',
  'Shooting photo / Défilé',
] as const;

export const AMENITIES_OPTIONS = [
  'Parking',
  'Terrasse',
  'Traiteur maison',
  'Sono / scène',
  'Vidéoprojecteur',
  'Climatisation',
  'Cuisine équipée',
  'Hôtel sur place',
  'Accessibilité PMR',
  'Wi-Fi haut débit',
  'Vue panoramique',
  'Hélipad',
  'Vestiaire',
  'Bar intégré',
  'Scène permanente',
  'Accès nuit / 24h',
] as const;

export const DUREE_MINIMUM_OPTIONS = [
  'Demi-journée',
  'Journée',
  'Week-end',
  'À la semaine',
] as const;

export const DEPARTEMENTS_IDF = [
  '75 — Paris',
  '77 — Seine-et-Marne',
  '78 — Yvelines',
  '91 — Essonne',
  '92 — Hauts-de-Seine',
  '93 — Seine-Saint-Denis',
  '94 — Val-de-Marne',
  "95 — Val-d'Oise",
] as const;

export const QUARTIERS_PARIS = [
  '1er', '2e', '3e', '4e', '5e', '6e', '7e', '8e', '9e', '10e',
  '11e', '12e', '13e', '14e', '15e', '16e', '17e', '18e', '19e', '20e',
  'Boulogne', 'Neuilly', 'Vincennes', 'Versailles', 'La Défense',
  'Marne-la-Vallée', 'Roissy / CDG',
] as const;
